/* eslint-disable */
import MFBasketsOrders from '../MutualFundsBaskets/MFBasketsOrders'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../Components/ui/tabs'
import MFIndividualOrders from './MFIndividualOrders'
import { ChevronRight } from 'lucide-react'
import { useEffect } from 'react'
import PostHogTracker from '../../utils/PostHogTracker'

const MFOrders = () => {
  useEffect(() => {
    // Track orders tab clicked
    PostHogTracker.ordersTabClicked()
    PostHogTracker.pageViewed('Order History')
  }, [])
  return (
    <>
      <div className='max-w-[1128px] mx-auto'>
        <h2 className='py-4 px-2 lg:px-0 font-semibold text-black-500 leading-6 tracking-[-4%] flex items-center gap-x-1'>
          My Orders
          <ChevronRight />
        </h2>
      </div>

      <div className='max-w-[1128px] mx-auto'>
        <Tabs defaultValue='Goals' className='relative mr-auto w-full'>
          <TabsList className='w-full justify-start rounded-none border-b bg-transparent p-0'>
            <TabsTrigger
              value='Goals'
              className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
            >
              Goals
            </TabsTrigger>

            <TabsTrigger
              value='Mutual Funds'
              className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
            >
              Mutual Funds
            </TabsTrigger>
          </TabsList>

          <TabsContent value='Mutual Funds'>
            <MFIndividualOrders />
          </TabsContent>

          <TabsContent value='Goals'>
            <MFBasketsOrders />
          </TabsContent>
        </Tabs>
      </div>
    </>
  )
}

export default MFOrders
